/**
 * Why the sender stopped a manual SMS send early — the job's `smsHaltReason`
 * (SMS manual send, plan C-2 step 5 / N4) and the `smsHaltReason` locale key
 * each one renders as. Every guest after the halt is skipped as `halted`.
 *
 * MIRROR of main-consumer `handlers/sms-manual.ts` `bookingOfResult` (the
 * fail / skip code of a dispatcher result with `stopFanOut`, see
 * `mongo-sms-dispatcher.ts` `STOP_FAN_OUT`, the account latch, the budget and
 * the claim) plus `SMS_MANUAL_HALT_PLUGIN_OFF` and its `stopped` fallback. A
 * code this map does not know renders as the generic `unknown` line carrying
 * the raw code. Static, like `smsSkipReason.ts`.
 */
export const SMS_HALT_REASON_KEYS = {
  /** The SMS service did not answer in time (brownout). */
  "sms-timeout": "timeout",
  /** The SMS service throttled the account. */
  "sms-throttled": "throttled",
  /** The account's sending quota (AWS spend limit) is used up. */
  "sms-quota": "quota",
  /** The SMS account refused the send. */
  "sms-account": "account",
  /** The platform's SMS account is blocked (latch). */
  sms_account_blocked: "accountBlocked",
  /** A send could not be claimed safely — nothing was sent twice. */
  "sms-unclaimable": "unclaimable",
  /** The organisation's allowance ran out. */
  "sms-budget-exhausted": "budgetExhausted",
  /** The event's SMS plugin was switched off during the send (N4: off means stop). */
  "plugin-off": "pluginOff",
  /** The sender's fallback when the result named no code. */
  stopped: "stopped",
} as const;

export type SmsHaltReasonCode = keyof typeof SMS_HALT_REASON_KEYS;
export type SmsHaltReasonKey = (typeof SMS_HALT_REASON_KEYS)[SmsHaltReasonCode];

export const SMS_HALT_REASON_CODES = Object.keys(SMS_HALT_REASON_KEYS) as SmsHaltReasonCode[];

/** The locale key for a stored code, or null for one this build does not know. */
export function smsHaltReasonKey(code: string): SmsHaltReasonKey | null {
  return Object.prototype.hasOwnProperty.call(SMS_HALT_REASON_KEYS, code)
    ? SMS_HALT_REASON_KEYS[code as SmsHaltReasonCode]
    : null;
}
